import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MUIDataTable from "mui-datatables";
import useSave from "../../../Hooks/useSave";
import { Autocomplete, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export default function NewCustomer() {
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  const [customerGroup, setCustomerGroup] = useState();
  const [customer, setCustomer] = useState({});

  function handleCreateCustomer() {
    fetchGraphql({
      query: `mutation CreateCustomer($customer: customerInput) {createCustomer(customer: $customer)}`,
      variables: { customer },
    }).then((result) =>
      navigate(`/customers/customer/${result.data.createCustomer}/company-info`)
    );
  }

  React.useEffect(() => {
    fetchGraphql({
      query: `query CustomerGroups {
        customerGroups {
          customerGroupCode
        }
      }`,
    }).then((result) => {
      setCustomerGroup(
        result.data.customerGroups.map((item) => ({
          label: item.customerGroupCode,
        }))
      );
    });
  }, []);

  React.useEffect(() => {
    // console.log(customer);
  }, [customer]);

  return (
    <Paper sx={{ minHeight: "300px", overflow: "auto", paddingBottom: "20px" }}>
      <DialogSave />
      <Typography sx={{ margin: "20px" }}>Customer Info</Typography>

      <Divider sx={{ marginBottom: "20px" }} />

      <Box sx={{ display: "flex" }}>
        <TextField
          sx={{ margin: "10px" }}
          value={customer.customerName || null}
          onChange={(e) =>
            setCustomer({ ...customer, customerName: e.target.value })
          }
          label="Name"
          color="primary"
        />

        <InputMask
          mask="(999) 999 - 9999"
          value={customer.customerPhoneNumber || null}
          onChange={(e) =>
            setCustomer({
              ...customer,
              customerPhoneNumber: e.target.value,
            })
          }
          disabled={false}
          maskChar=" "
        >
          {() => (
            <TextField
              sx={{ margin: "10px" }}
              label="Phone Number"
              color="primary"
            />
          )}
        </InputMask>

        <InputMask
          mask="(999) 999 - 9999"
          value={customer.customerAltPhoneNumber || null}
          onChange={(e) =>
            setCustomer({
              ...customer,
              customerAltPhoneNumber: e.target.value,
            })
          }
          disabled={false}
          maskChar=" "
        >
          {() => (
            <TextField
              sx={{ margin: "10px" }}
              label="Alt Phone Number"
              color="primary"
            />
          )}
        </InputMask>

        <TextField
          sx={{ margin: "10px" }}
          key="2"
          value={customer.customerBillingEmails || null}
          onChange={(e) =>
            setCustomer({ ...customer, customerBillingEmails: e.target.value })
          }
          label="Emails"
          placeholder="add coma between emails"
          color="primary"
        />

        {customer.customerIsGroup ? (
          <TextField
            sx={{ margin: "10px" }}
            key="2"
            value={customer.customerGroupCode || null}
            onChange={(e) =>
              setCustomer({ ...customer, customerGroupCode: e.target.value })
            }
            label="Group Code"
            color="primary"
          />
        ) : null}

        {!customer.customerIsGroup ? (
          <Autocomplete
            disablePortal
            options={customerGroup || []}
            value={customer.customerGroupCode}
            onChange={(event, value) => {
              const copyState = { ...customer };

              copyState.customerGroupCode = value.label;

              setCustomer(copyState);
            }}
            sx={{ width: "220px", margin: "10px" }}
            renderInput={(params) => (
              <TextField {...params} label="Customer Group" />
            )}
          />
        ) : null}
      </Box>

      <FormControlLabel
        sx={{ margin: "5px" }}
        control={
          <Checkbox
            checked={customer.customerIsGroup}
            onChange={(e) => {
              const copyState = { ...customer };

              if (e.target.checked) {
                delete copyState.customerGroup;
              } else {
                delete copyState.customerGroupCode;
              }

              setCustomer({ ...copyState, customerIsGroup: e.target.checked });
            }}
          />
        }
        label="Is Group"
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginTop: "20px",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography sx={{ margin: "20px" }}>Billing Address</Typography>

          <Divider sx={{ marginBottom: "20px" }} />

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <TextField
              sx={{ margin: "10px", width: "490px" }}
              value={customer.customerBillingAddress?.addressLine || null}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  customerBillingAddress: {
                    ...customer.customerBillingAddress,
                    addressLine: e.target.value,
                  },
                })
              }
              label="Name"
              variant="outlined"
            />

            <TextField
              sx={{ margin: "10px", width: "490px" }}
              value={customer.customerBillingAddress?.addressLine2 || null}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  customerBillingAddress: {
                    ...customer.customerBillingAddress,
                    addressLine2: e.target.value,
                  },
                })
              }
              label="Address"
              variant="outlined"
            />

            <Box>
              <TextField
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerBillingAddress?.city || null}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerBillingAddress: {
                      ...customer.customerBillingAddress,
                      city: e.target.value,
                    },
                  })
                }
                label="City"
                color="primary"
              />

              <TextField
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerBillingAddress?.state || null}
                required={true}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerBillingAddress: {
                      ...customer.customerBillingAddress,
                      state: e.target.value,
                    },
                  })
                }
                label="State"
                color="primary"
              />

              <TextField
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerBillingAddress?.zip || null}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerBillingAddress: {
                      ...customer.customerBillingAddress,
                      zip: e.target.value,
                    },
                  })
                }
                label="Zip"
                color="primary"
              />
            </Box>
          </Box>
        </Box>

        <Box sx={{ margin: "10px 20px 0px 0px" }}>
          <Tooltip title="Copy">
            <IconButton
              onClick={() => {
                const copyState = { ...customer };

                const billingAddress = { ...copyState.customerBillingAddress };

                // console.log(copyState);

                copyState.customerShippingAddress = billingAddress;

                setCustomer(copyState);
              }}
            >
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Divider orientation="vertical" flexItem />

        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography sx={{ margin: "20px" }}>Shipping Address</Typography>

          <Divider sx={{ marginBottom: "20px" }} />

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <TextField
              key="2"
              sx={{ margin: "10px", width: "490px" }}
              value={customer.customerShippingAddress?.addressLine || null}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  customerShippingAddress: {
                    ...customer.customerShippingAddress,
                    addressLine: e.target.value,
                  },
                })
              }
              label="Name"
              variant="outlined"
            />

            <TextField
              key="2"
              sx={{ margin: "10px", width: "490px" }}
              value={customer.customerShippingAddress?.addressLine2 || null}
              onChange={(e) =>
                setCustomer({
                  ...customer,
                  customerShippingAddress: {
                    ...customer.customerShippingAddress,
                    addressLine2: e.target.value,
                  },
                })
              }
              label="Address"
              variant="outlined"
            />

            <Box>
              <TextField
                key="2"
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerShippingAddress?.city || null}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerShippingAddress: {
                      ...customer.customerShippingAddress,
                      city: e.target.value,
                    },
                  })
                }
                label="City"
                color="primary"
              />

              <TextField
                key="2"
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerShippingAddress?.state || null}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerShippingAddress: {
                      ...customer.customerShippingAddress,
                      state: e.target.value,
                    },
                  })
                }
                label="State"
                color="primary"
              />

              <TextField
                key="2"
                sx={{ margin: "10px", width: "150px" }}
                value={customer.customerShippingAddress?.zip || null}
                onChange={(e) =>
                  setCustomer({
                    ...customer,
                    customerShippingAddress: {
                      ...customer.customerShippingAddress,
                      zip: e.target.value,
                    },
                  })
                }
                label="Zip"
                color="primary"
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Typography sx={{ margin: "20px" }}>Customer Notes</Typography>

      <Divider sx={{ marginBottom: "20px", marginTop: "10px" }} />

      <TextField
        sx={{ margin: "10px", width: "500px" }}
        multiline
        onChange={(e) =>
          setCustomer({
            ...customer,
            customerNote: e.target.value,
          })
        }
        label="Notes"
        value={customer.customerNote || null}
        color="primary"
      />

      <Divider sx={{ marginBottom: "20px", marginTop: "10px" }} />

      <Button
        variant="contained"
        sx={{
          width: "fit-content",
          marginLeft: "10px",
        }}
        onClick={handleCreateCustomer}
      >
        Create customer
      </Button>
    </Paper>
  );
}
